import LK_Export from '../../images/LK_Export.js';
import React, { useContext, useEffect, useRef, useState } from 'react';
import {Box,Button, Divider} from '@mui/material';
import CustomTooltip from './CustomTooltip.js';

/* 
headerList (string array) :It is array of string which contains the name of header of each column in csv.
data (object array) : Array of objects with each object containing the data of single row inn csv.
fileName (string) : Name of the csv file that is being exported.
fieldList (string array) : Array of string containing names of properties of the object.
*/

export default function CustomExportButton({data,fileName,headerList,fieldList,width}) {

    function onClick(){
        // search.searchText=selectedValue;
        // setSearch(search);
        // Convert the data array into a CSV string
            let temp=[]
            data.map(item => {
                let temp1=[]
                fieldList.map(field => [...temp1,item[field]]) // Map your data fields accordingly
                temp = [...temp,[...fieldList.map(field => item[field])]]
                // return temp
                }
                
            ) // Map your data fields accordingly
            const csvString = [
                [...headerList], // Specify your headers here
                ...temp.map(item => [item]) // Convert each item to a string
            ]
            .map(row => row.join(","))
            .join("\n");
        
            // Create a Blob from the CSV string
            const blob = new Blob([csvString], { type: 'text/csv' });
        
            // Generate a download link and initiate the download
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'download.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        };

    return (
    <CustomTooltip title={"Export"} offset={[30,-20]} placement={'right-end'}>
        <Button
            onClick={onClick}
            type="text"
            style={{
                marginBottom: "0px",
                marginTop:"0px",
                color:"#008CD7",
                alignSelf:"center",
                justifySelf:"end",
                minWidth:width?width:'auto',
                padding:0,
            }}
        >
            <LK_Export color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/>
        </Button>
    </CustomTooltip>
    )
}